(function () {
  const selectors = {
    section: '.js-scroll-slider',
    slider: '.js-scroll-slider-swiper',
    slide: '.js-scroll-slider-slide',
    sliderSettings: '.js-scroll-slider-settings',
    noMousewheelClass: '.js-scroll-slider-no-mousewheel',
  };

  const Swiper = window.Swiper;
  const section = document.querySelector(selectors.section);
  const slider = section?.querySelector(selectors.slider);
  const slides = section?.querySelectorAll(selectors.slide) || [];
  const sliderSettingsDOM = section?.querySelector(selectors.sliderSettings);
  const noMousewheelDOM = section?.parentElement?.querySelector(selectors.noMousewheelClass);
  let swiperSlider, sliderSettings, activeSlide, inViewport, isScrollActive, isSwiperEdge, enableAutoScroll, preventScroll;

  let supportsPassive = false;
  try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
      get: function () { supportsPassive = true; }
    }));
  } catch(e) {}

  const wheelOpt = supportsPassive ? { passive: false } : false;
  const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
  const keys = {37: 1, 38: 1, 39: 1, 40: 1};
  const mobileMediaQuery = window.matchMedia('(max-width: 767px)');

  function init() {
    if (slider && sliderSettingsDOM && Swiper && slides.length > 1) {
      initSwiper();
      addEventListeners();
      inViewport = isElementMoreThan70PercentVisible(activeSlide);
      checkScroll();
      onResize();
    }
  }

  function initSwiper() {
    sliderSettings = getSettings();

    if (!sliderSettings) {
      return;
    }

    swiperSlider = new Swiper(slider, {
      ...sliderSettings,
    });

    activeSlide = swiperSlider.slides[swiperSlider.activeIndex];
    slider.classList.remove('swiper-not-initialized');

    swiperSlider.on('slideChange', function (swiper) {
      activeSlide = swiper.slides[swiper.activeIndex];
      updateSlideVideos();
    });

    updateSlideVideos();

    swiperSlider.on('toEdge', function () {
      isSwiperEdge = true;
      disableScroll();
      setTimeout(() => enableScroll(), 500);
    });

    swiperSlider.on('fromEdge', function () {
      isSwiperEdge = false;
      enableAutoScroll = false;
    });
  }

  function onResize() {
    if (isMobile()) {
      swiperSlider.disable();

      const allVideos = slider.querySelectorAll('.js-scroll-slider-video');

      allVideos.forEach(function (video) { video.play().catch(function () {}); });
    } else {
      swiperSlider.enable();
      updateSlideVideos();
    }
  }

  function isMobile() {
    return mobileMediaQuery.matches;
  }

  function isElementMoreThan70PercentVisible(el) {
    if (!el) {
      return;
    }

    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;

    const elementArea = rect.width * rect.height;
    const viewportArea = windowHeight * windowWidth;

    const visibleWidth = Math.max(0, Math.min(rect.right, windowWidth) - Math.max(rect.left, 0));
    const visibleHeight = Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));
    const visibleArea = visibleWidth * visibleHeight;

    if (elementArea < viewportArea) {
      return visibleArea >= 0.7 * elementArea;
    } else {
      return visibleArea >= 0.7 * viewportArea;
    }
  }

  function addEventListeners() {
    if (noMousewheelDOM) {
      window.addEventListener('scroll', checkScroll);
    }

    mobileMediaQuery.addEventListener('change', onResize);
  }

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
  }

  function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  }

  function checkScroll() {
    if (!isScrollActive && !isMobile()) {
      inViewport = isElementMoreThan70PercentVisible(activeSlide);

      if (typeof inViewport !== 'boolean') {
        return;
      }

      if (!inViewport) {
        enableAutoScroll = true;
      }

      noMousewheelDOM.classList.toggle('scroll-slider__no-mousewheel--hidden', inViewport);

      if (inViewport && enableAutoScroll) {
        isScrollActive = true;
        enableAutoScroll = false;

        scrollToElement(section);
      }
    }
  }

  function getSettings() {
    try {
      return JSON.parse(sliderSettingsDOM.textContent);
    } catch {
      return null;
    }
  }

  function scrollToElement(el) {
    const body = document.body;
    const originalScrollBehavior = window.getComputedStyle(body).scrollBehavior;

    body.style.scrollBehavior = 'smooth';

    if (el) {
      const elementRect = el.getBoundingClientRect();
      const elementHeight = elementRect.height;
      const viewportHeight = window.innerHeight;

      let scrollTop;
      if (elementHeight < viewportHeight) {
        const elementCenter = elementRect.top + window.scrollY + elementHeight / 2;
        scrollTop = elementCenter - viewportHeight / 2;
      } else {
        scrollTop = elementRect.top + window.scrollY;
      }

      window.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }

    setTimeout(() => {
      body.style.scrollBehavior = originalScrollBehavior;
      isScrollActive = false;
    }, 500);
  }

  function updateSlideVideos() {
    if (isMobile()) {
      return;
    }

    const allVideos = slider.querySelectorAll('.js-scroll-slider-video');

    if (!swiperSlider) {
      return;
    }

    const active = swiperSlider.slides[swiperSlider.activeIndex];

    allVideos.forEach(function (video) {
      if (active && active.contains(video)) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });
  }

  init();
})();
